"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Audio;

var _Audio = require("@adobe/react-spectrum-workflow/dist/Audio");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Audio(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Audio.A4uAudio, null));
}